import { ReactComponent as LinkIcon } from '../assets/benefits/link.svg';
import { ReactComponent as ShieldIcon } from '../assets/benefits/shield.svg';
import { ReactComponent as UserIcon } from '../assets/benefits/user.svg';

export const benefitsItems = [
  {
    icon: LinkIcon,
    label: 'Доступ к играм в одно нажатие',
  },
  {
    icon: ShieldIcon,
    label: 'Защита от блокировок',
  },
  {
    icon: UserIcon,
    label: 'Постоянный логин',
  },
];
